/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Complete_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to complete onboarding. Please try again." |
*
* @param {Onboarding_Complete_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_complete_error = /** @type {((inputs?: Onboarding_Complete_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Complete_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Onboarding konnte nicht abgeschlossen werden. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to complete onboarding. Please try again.")
});